import {RewardType} from "@/Core/Reward/RewardInfo";
import DataMgr from "@/Fwk/DataMgr";
// import {GuideIDType, GuiderConst} from "@/Core/GuideMgr";

export class BaseInfo {
    //余额版本和(gc更新版本+sc更新版本)
    balanceVersion: number = 0;
    //可提现sc余额
    availableScAmount: number = 0;
    //可提现sc余额(万分位)
    convertAvailableScAmount: number = 0;
    //赠送sc余额(不可提现)(万分位)
    convertRewardScAmount: number = 0;
    //scAmountAtom this.convertAvailableScAmount + this.convertRewardScAmount;
    //总的SC显示的呢
    convertTotalScAmount: number = 0;
    //游戏经验
    gameExp: number = 0;
    //游戏等级
    gameLevel: number = 0;
    //gc余额
    gcAmount: number = 0;
    //赠送sc余额(不可提现)
    rewardScAmount: number = 0;
    //vip经验
    vipExp: number = 0;
    //vip等级
    vipLevel: number = 0;





    ///====================================

    //动态计算 SC
    scCountAtom: number = 0;
    scCount: number = 0;

    //可兑换SC
    scAvailableToRedeemAtom: number = 0;
    scAvailableToRedeem: number = 0;

    //奖励sc
    scUnPlayedBalanceAtom: number = 0;
    scUnPlayedBalance: number = 0;

}

export enum LoginUserType {
    null = 0, //初始用户
    visitor = 1, //游客
    normal = 2, //普通用户
}

export class UserGlobalInfo {
    baseInfo: BaseInfo;
    extJson: Record<string, any>; // 可根据实际情况调整
    userId: number = 0;
    loginType: LoginUserType;
    expireTime: number = 0;
    token: string = '';
    nickName: string = '';
    zipCode: string = '';
    rewardType: RewardType;
    // guideID: GuideIDType; //1001显示引导 -1完成引导

    //是否有初始化更新数据
    // isSyncData: boolean = false;
    // syncData: Record<string, any>; // 可根据实际情况调整

    constructor() {
        this.baseInfo = new BaseInfo();
        this.extJson = {};
        this.userId = 0;
        this.loginType = LoginUserType.visitor;
        this.expireTime = 0;
        this.token = '';
        this.rewardType = RewardType.GC;
        this.nickName = 'Name';
        // this.guideID = DataMgr.getStorage(GuiderConst.guide_id_key) as GuideIDType;
        // this.syncData = {} as Record<string, any>;
    }

    // get isTokenOk(){
    //     if (this.token && this.token.length > 0){
    //         return true;
    //     }
    //     return false;
    // }
}


// export default class SRewardData
// {
//     scAmountAtom:number => scAvailableToRedeemAtom + scUnPlayedBalanceAtom; //sc
//     scAvailableToRedeemAtom:number; //可兑换sc
//     scUnPlayedBalanceAtom:number; //奖励sc
//     gcAmount:number; //gc
// }